import './OrderInfo.less';
export { default as OrderInfo } from './OrderInfo.js';
export { default } from './OrderInfo.js';